module.exports = "/_next/static/images/slide14-c19e9ab3ed0fceb22bf4c9629900d99f.webp";